/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userTransferRecall.internal

import features.userTransferRecall.models.TransferActionResultModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class TransferRecallServiceImpl : TransferRecallService {

    private val transferRecallRequest = TransferRecallRequest()

    override suspend fun recallTransfer(
        overrideHeaders : Map<String, String>?,
        recallId: String    ): Result<TransferActionResultModel> {
        return transferRecallRequest.recallTransfer(
            overrideHeaders = overrideHeaders,
            recallId = recallId        ).toModel()
    }
}
